import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';

export const firebaseConfig = {
    apiKey: "AIzaSyA_30OZ08ZPCDwCu_gwHSnmYuNkb6GRPpc",
    authDomain: "civil-willow-211119.firebaseapp.com",
    databaseURL: "https://civil-willow-211119.firebaseio.com",
    projectId: "civil-willow-211119",
    storageBucket: "civil-willow-211119.appspot.com",
    messagingSenderId: "709281914321",
    appId: "1:709281914321:web:b03f54f94d991b0e9ad4f0",
    measurementId: "G-JTQQMVGPL6"
};

firebase.initializeApp(firebaseConfig);
firebase.analytics()

export const RESTAURANT_MENU = firebase.database().ref("menu");
export const MENU_CATEGORIES = firebase.database().ref("categories");
export const RESTAURANT_INFO = firebase.database().ref("restaurants");
export const RESTAURANT_FEEDS = firebase.database().ref("post");

export default firebase;